import React, { useEffect } from 'react'
import Navbar from '../../landing/header/Navbar'
import Banner from './Banner/Banner'

const ScrexDetailPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <div className="wrapper-detailpage">
                <Navbar />
                <Banner />
            </div>
        </>
    )
}

export default ScrexDetailPage



